module.exports = __webpack_public_path__ + "img/easy-and-fast.08057715.png";